import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/credits')({
  component: lazyRouteComponent(() => import('./-credits.lazy'), 'default'),
  validateSearch: (search: Record<string, unknown>) => ({
    orgId: typeof search.orgId === 'string' ? search.orgId : undefined,
  }),
});
